import {
    browserTracingIntegration,
    captureConsoleIntegration,
    getCurrentScope,
    init,
    replayIntegration
} from '@sentry/vue'
import {type User} from '@/models/auth'
import {useRouter} from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  if (nuxtApp.$config.public.environment !== 'DEV') {
    console.log('Sentry is active')
    const router = useRouter()

    const ignoredMessages = [
      'AxiosError: Network Error',
      'interaction_in_progress',
      'Auth error, method:',
      'Error: Request failed with status code 401',
      'Page not found: /_nuxt/',
    ]


    init({
      app: nuxtApp.vueApp,
      dsn: nuxtApp.$config.public.sentryDsn,
      integrations: [
          captureConsoleIntegration({
            levels: ['error']
          }),
        browserTracingIntegration({
          router: router
          }),
        replayIntegration(),
      ],
      beforeSend(event) {
        const message =
            event?.exception?.values?.[0]?.value ||
            event?.message ||
            ''

        if (ignoredMessages.some(ignored => message.includes(ignored))) {
          return null // Ignore
        }

        if (event.user) {
            delete event.user.email
            delete event.user.username
            delete event.user.name
            delete event.user.id
            delete event.user.geo
        }

        return event
      },
      ignoreErrors: ignoredMessages,
      environment: nuxtApp.$config.public.environment,
      release: `${nuxtApp.$config.public.version}:${nuxtApp.$config.public.environment}`,
      tracesSampleRate: 0.6,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })

    {
      const scope = getCurrentScope();
      try {
        const user: User = JSON.parse(
            (window as any).localStorage.getItem('user')
        )
        if (user) {
          scope.setUser({
            email: user.Email,
            id: user.Id,
            username: user.Name
          })
        }
      } catch (e) {
        console.warn('Error configuring sentry scope', e)
      }
    }
  }
})
